import React from "react";
import PropTypes from "prop-types";
import { pure } from "recompose";
import styled from "styled-components";
import classnames from "classnames";
import { Popup } from "@witbooking/react-components";
import { renderHTML } from "../../../../utils/misc";
import constants from "../../../../utils/constants";
import { InfoWhiteIcon } from "../../../../theme/assets";

const CustomMessage = styled.div`
  > p {
    padding: 5px 20px 10px 22px;
  }
`;

function ModalMessage({ messages, onCloseModal }) {
  return (
    <Popup srcLogo={<InfoWhiteIcon />} closeWindow={onCloseModal}>
      <CustomMessage
        className={classnames("wbkv9-Custom-Message")}
        dangerouslySetInnerHTML={renderHTML(messages.get(0).get("content"))}
      />
    </Popup>
  );
}

ModalMessage.propTypes = {
  messages: PropTypes.object.isRequired,
};

export default pure(ModalMessage);
